import React from 'react';
import Markdown from 'react-remarkable';

import checkOverflow from '../utils/checkModalOverflow';

class TermsModal extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isVisible !== nextProps.isVisible) {
            checkOverflow(nextProps.isVisible);
        }
    }

    render() {
        let classes = "modal-overlay terms-modal-overlay";
        if (this.props.isVisible) classes += " active";

        return (
            <div onClick={this.toggleModal.bind(this)} className={classes}>
                <div onClick={this.modalClick.bind(this)} className="modal whitebox">
                    <header className="modal-header">
                        <h1>{this.props.terms.title}</h1>
                        <button className="close" onClick={this.toggleModal.bind(this)}><span>&times;</span></button>
                    </header>
                    <div className="modal-content">
                        <Markdown source={this.props.terms.content} />
                    </div>
                </div>
            </div>
        );
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    toggleModal() {
        this.setState({updatePosted: false});
        this.props.toggleModal();
    }
}

export default TermsModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/TermsModal.js
 **/